import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { User } from "../../const/types";
import { useRef } from "react";

interface Props {
  data: User;
}

export default function ListItemPenggunaDashboard({ data }: Props) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = useRef(null);

  return (
    <>
      <HStack
        py={3}
        px={5}
        borderBottom={"1px solid var(--divider)"}
        _hover={{ bg: "var(--divider)" }}
        cursor={"pointer"}
        justify={"space-between"}
        onClick={onOpen}
      >
        <Text noOfLines={1}>{data.name}</Text>
      </HStack>

      <Modal isOpen={isOpen} onClose={onClose} initialFocusRef={initialRef}>
        <ModalOverlay />

        <ModalContent ref={initialRef}>
          <ModalCloseButton />

          <ModalHeader>Detail Pengguna</ModalHeader>

          <ModalBody>
            <VStack align={"stretch"}>
              <HStack>
                <Text w={"120px"} opacity={0.6}>
                  Nama
                </Text>
                <Text>{data.name}</Text>
              </HStack>

              <HStack>
                <Text w={"120px"} opacity={0.6}>
                  Username
                </Text>
                <Text>{data.username}</Text>
              </HStack>

              <HStack>
                <Text w={"120px"} opacity={0.6}>
                  Email
                </Text>
                <Text>{data.email}</Text>
              </HStack>

              <HStack>
                <Text w={"120px"} opacity={0.6}>
                  Telepon
                </Text>
                <Text>{data.phone}</Text>
              </HStack>
            </VStack>
          </ModalBody>

          <ModalFooter>
            <Button w={"100%"} onClick={onClose} className="btn-solid">
              Tutup
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
